//angular imports
import { 
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    InputSignal, 
    TemplateRef, 
    ViewContainerRef, 
    effect, 
    input 
} from "@angular/core";

import { 
    CdkPortalOutletAttachedRef, 
    ComponentPortal, 
    Portal, 
    TemplatePortal
} from "@angular/cdk/portal";

//local imports
import { PresenterHelper, PresenterModelKey } from "./presenter-type";
import { Transforms } from "@app/shared/helpers";

@Component({
    selector: "presenter",
    templateUrl: "./presenter.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PresenterComponent
{    
    public presenterOutlet: Portal<any>;
    
    public data: InputSignal<any> = input<any>();
    public key: InputSignal<string> = input<string>();
    public allowFallback = input(false, {
        transform: Transforms.toBoolean
      });
      
    public finalFallbackTemplate = input<TemplateRef<any>>(null);

    constructor(cdf: ChangeDetectorRef, viewContainerRef: ViewContainerRef) {

        effect(() =>
        {        
            let data = this.data();
            if (!data) return;
                        
            let lookupKey: PresenterModelKey = { 
                model: data,
                key: this.key(),                
            }

            let allowFallback = this.allowFallback();
            let template = PresenterHelper.getTemplate(lookupKey, allowFallback);

            if(!template) {

                let finalFallbackTemplate = this.finalFallbackTemplate();                
                if (allowFallback && finalFallbackTemplate) {
                    this.presenterOutlet = new TemplatePortal(finalFallbackTemplate,  viewContainerRef, {
                        $implicit: data,
                        data: data
                    });
                }
                return;
            }

            this.presenterOutlet = new ComponentPortal(template);            
            
            cdf.markForCheck();
        });
    }

    public attached(ref: CdkPortalOutletAttachedRef)
    {
        ref = ref as ComponentRef<any>;
        ref.instance?.data?.set(this.data());        
    }
}